import { initialFormValuesMapper } from '@huspy/forge/features';
import {
  KYCApplicant,
  EmploymentKYCData,
  KYCData,
} from '@huspy/forge/types';

import { IS_SPAIN_ENV } from '@modules/core/utils';

export const getInitialValues = (applicantsKYC: KYCApplicant[]) => {
  const {
    employmentAE,
    employmentES,
    personal,
    residency,
    liabilities,
    incomeAE,
    incomeEs,
  } = initialFormValuesMapper;

  return {
    applicants: applicantsKYC.map((applicant) => ({
      applicantId: applicant.applicant_id,
      applicantType: applicant.applicant_type,
      personal_information: personal.getInitialValues(
        applicant.personal_information
      ),
      residential_information: residency.getInitialValues(
        applicant.residential_information
      ),
      incomes: IS_SPAIN_ENV
        ? incomeEs.getInitialValues(applicant.financial_information.incomes)
        : incomeAE.getInitialValues(applicant.financial_information.incomes),
      employment_information: IS_SPAIN_ENV
        ? employmentES.getInitialValues(
          applicant.employment_information as unknown as EmploymentKYCData<'ES'>
        )
        : employmentAE.getInitialValues(applicant.employment_information),
      ...liabilities.getInitialValues(
        applicant.financial_information.liabilities
      ),
    })),
  };
};

export const getApplicantFullName = (applicant: KYCApplicant) =>
  `${applicant.personal_information.first_name} ${applicant.personal_information.last_name}`;

export function convertToApplicantType(data: KYCData): KYCApplicant[] {
  return Object.entries(data).map(([applicantId, applicantData]) => ({
    ...applicantData,
    applicant_id: applicantId,
  }));
}
